import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";

import { useNavigate } from 'react-router-dom';
import LanguageLanding from '../../translation/Language-LandingPage';
import i18next from 'i18next'; 
const LandingPage = () => {

    const [captchaText, setCaptchaText] = useState('');
    const [name,setName] = useState("")
    const [email,setEmail] = useState("")
    const [phone,setPhone] = useState("")
    const [message,setMessage] = useState("")

    var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const submit=()=>{
        if(name == ""){
            alert("Enter Name")
        }else if(email == ""){
            alert("Enter email")
        }else if(!emailPattern.test(email)){
            alert("Enter valid email")
        }else if(phone == ""){
            alert("Enter phone no")
        }else if(message == ""){
            alert("Enter message")
        }else{
            const valu =  {
                "name":name,
            "last_name":name,
            "email":email,
            "phone":phone,
            "subject":"Tokens",
            "description":message
            }
            fetch("https://api.catzapp.com/recruiter/ticket_support/", {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json', // Set the content type based on your API requirements
                },
                body: JSON.stringify(valu),
              })
            .then((data) => {
              console.log('Response from server:', data.status);
              if(data.status == 200){
                alert("We will contact you soon")
              }else{
                alert("something went wrong")
              }
            })
            .catch((error) => {
              console.error('Error:', error);
            });

        }
    }




    const navigate = useNavigate();

    // useEffect(() => {
    //     generateCaptcha();
    // }, []);

    const handleClick = (e) => {
        i18next.changeLanguage(e.target.value)
    }


    // const generateCaptcha = () => {
    //     const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    //     let captcha = '';
    //     for (let i = 0; i < 6; i++) {
    //         captcha += characters.charAt(Math.floor(Math.random() * characters.length));
    //     }
    //     setCaptchaText(captcha);
    //     document.getElementById('randcode').value = captcha;
    // };

    const handleLogin = () => {
        navigate('/login')
    }
    const handleRegistration = () => {
        navigate('/registration')
    }


    const { t } = useTranslation();
    return (
        <div style={{ background: 'white' }}>


            <div className="header-over header-sticky">
                <div id="wrapper">

                    <nav className="navbar navbar-expand-lg fixed-top bg-transparent">
                        <div className="container-fluid" >
                            <div className=" d-flex ">
 


                                <a className="navbar-brand" href="#">
                                    <img src="../images/logo-atzapp_white.png" width="110" alt="..." />

                                </a>
                            </div>


                            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>

                            <ul class="navbar-nav fs-6">
                                <li class="nav-item active">
                                    <a className="nav-link scroll-to" href="#">
                                        {t('Home')}
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a className="nav-link scroll-to" href="#">

                                        {t('To the employer')}
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a className="nav-link scroll-to" href="#">

                                        {t('For the employee')}
                                    </a>

                                </li>
                                <li class="nav-item">
                                    <a className="nav-link scroll-to" href="#">

                                        {t('For the organization')}
                                    </a>
                                </li>
                            </ul>

                            <div className="btn btn-primary px-4 admin-btn btn " onClick={handleLogin} style={{ cursor: "pointer" }}>{t('Login')}</div>
                            <button className="btn btn-primary px-4 admin-btn btn " onClick={handleRegistration} style={{ cursor: "pointer" }}>{t('SignUp')}</button>
                            <LanguageLanding onChange={(e) => handleClick(e)} />
                        </div>
                    </nav>




                    <div class="slideshow   "  >
                        <img src="../images/slider-1.jpeg" class="slide" />
                        <img src="../images/slider-2.jpg" class="slide" />


                        {/* <img src='../images/slider-1.jpeg' style={{width:"100%"}}/> */}


                        <div className="container">

                            <div className="text-center-md text-center-xs d-middle justify-content-start">

                                <div className="text-white py-7" data-aos="fade-in" data-aos-delay="0" data-aos-offset="0">


                                    <p className="h4 mb-0 " style={{ color: 'black', zIndex: '9999999999999' }}>



                                        {t('Connects employees and employers lightning fast')}


                                        {/* 
                                            Yhdistää työntekijät ja työnantajat <br /> salamannopeasti


                                            Ühendab töötajad ja tööandjad <br /> välkkiirelt */}
                                    </p>
                                </div>

                            </div>

                        </div>

                    </div>

                    <div id="section_home" className="section">
                        <div className="container">




                            <div className="row mt-5">

                                <div className="order-2 order-lg-1 col-12 col-lg-6 col-xl-6 ">



                                    <p className="fw-bold mb-3 fs-2 topic">{t('What is Catzapp Job?')}</p>

                                    <p>{t('Catzapp Job is an innovative communication tool that facilitates job search and recruitment by connecting suitable job seekers and employers together.')} </p>
                                    <br />

                                    <p>{t('Join our community today and find the right job for you or the right person for your company today')}!</p>


                                </div>

                                <div className="order-1 order-lg-2 col-12 col-lg-6 col-xl-6 text-center mb-5">


                                    <img className="w-100 rounded lazy" src="../images/catzapp-home2.jpg" alt="none" />


                                </div>

                            </div>

                        </div>
                    </div>

                    <div id="section_to_the_employer" className="section">
                        <div className="container">


                            <div className="max-w-600 mx-auto text-center mb-6" >
                                <p className="fw-bold mb-5 fs-2 topic">{t('To the employer')}</p>

                            </div>


                            <div className="row">

                                <div className="order-2 order-lg-1 col-12 col-lg-6 col-xl-6  ">


                                    <p>{t('As a recruiter, you can streamline the recruitment process.')}</p>
                                    <br />
                                    <p>{t('With Catzapp Job, you can easily search and filter qualified applicants. You no longer have to spend countless hours looking for the right employee for the required shift or task.')}</p>
                                    <br />
                                    <p>{t('The application offers the employer the opportunity to quickly review the applicants information and assess their suitability for the required job.How easily can you find substitutes for unexpected absences at the moment')}?</p>
                                    <br />
                                    <p>{t('Download the Catzapp Job company profile and use it immediately mobile application and announce an open shift or job')}!</p>

                                    <br />
                                    <div style={{ display: 'flex', justifyContent: "flex-start ", marginTop: '10px' }} >
                                        <a style={{ border: 'none', background: 'none', }} href='https://play.google.com/store/apps/details?id=com.finland'>
                                            <img src='../images/playstore.png' alt='' style={{ width: '30%' }} />

                                        </a>
                                        {/* <div style={{ border: 'none', background: 'none', }}>
                                            <img src='../images/appstore.png' alt='' style={{ width: '30%' }} />

                                        </div> */}
                                        <a href='#'>
                                            <div style={{ border: 'none', background: 'none', }}>
                                                <img src="../images/webimage.png" alt="hello" style={{ width: '40px', height: '40px' }} />
                                            </div>
                                        </a>

                                    </div>

                                </div>




                                <div className="order-1 order-lg-2 col-12 col-lg-6 col-xl-6 text-center mb-5">


                                    <img className="w-100  lazy" src="../images/Catzap-työnantajalle.jpg" />

                                </div>

                            </div>

                        </div>
                    </div>


                    <div id="section_for_the_employer" className="section">
                        <div className="container">


                            <div className="max-w-600 mx-auto text-center mb-6" >
                                <p className="fw-bold mb-5 fs-2 topic">{t('For the employee')}</p>

                            </div>


                            <div className="row">

                                <div className="order-1 order-lg-2 col-12 col-lg-6 col-xl-6 ">

                                    <p>{t('Are you excited to browse job advertisements that suits your skills and working experience')}?</p>
                                    <br />
                                    <p>{t('As an employee you  have access for vast selection of job ads that corresponds with your  work experience! The app offer its user a fast track to become employed and to earn more! Start the new era of job seeking today!')}</p>
                                    <br />
                                    <div style={{ display: 'flex', justifyContent: "flex-start", marginTop: '10px' }} >
                                    <a style={{ border: 'none', background: 'none', }} href='https://play.google.com/store/apps/details?id=com.finland'>
                                            <img src='../images/playstore.png' alt='' style={{ width: '30%' }} />

                                        </a>
                                        {/* <div style={{ border: 'none', background: 'none', }}>
                                            <img src='../images/appstore.png' alt='' style={{ width: '30%' }} />

                                        </div> */}


                                    </div>




                                </div>

                                <div className="order-2 order-lg-1 col-12 col-lg-6 col-xl-6 text-center mb-5 catzapp-img">


                                    <img className="w-100  lazy" src="../images/Catzap-työntekijälle.jpg" alt="Rekrytoijana voit virtaviivaistaa rekrytointiprosessia." />


                                </div>

                            </div>

                        </div>
                    </div>

                    <div id="section_for_the_organization" className="section">
                        <div className="container">


                            <div className="max-w-600 mx-auto text-center mb-6" >
                                <p className="fw-bold mb-5 fs-2  topic ">{t('For the organization')}</p>

                            </div>


                            <div className="row">

                                <div className="order-2 order-lg-1 col-12 col-lg-6 col-xl-6 ">


                                    <p>{t('Catzapp offers organizations their  own customized  application that enhances internal recruitment. It also allows employees in the organization to find open positions thta match their experience. How does your organization find substitutes for unexpected absences at the moment? How often do you need to find a replacement right away')}?</p>
                                    <br />
                                    <p>{t("The application helps to make a better result, saves time and money, improve the communication of open shifts by using the Catzapp Job application.Leave a contact request and let's discuss how Catzapp could be useful for your organization too")}!</p>
                                    <br />
                                    <div style={{ display: 'flex', justifyContent: "space-between ", marginTop: '10px' }} >
                                        {/* <div style={{ border: 'none', background: 'none', }}>
                                            <img src='../images/playstore.png' alt='' style={{ width: '50%' }} />

                                        </div>
                                        <div style={{ border: 'none', background: 'none', }}>
                                            <img src='../images/appstore.png' alt='' style={{ width: '50%' }} />

                                        </div> */}
                                        <a href='#'>
                                            <div href='' style={{ border: 'none', background: 'none', }}  >
                                                <img src="../images/webimage.png" alt="hello" style={{ width: '40px', height: '40px' }} />
                                            </div>
                                        </a>

                                    </div>

                                </div>

                                <div className="order-1 order-lg-2 col-12 col-lg-6 col-xl-6 text-center mb-5">

                                    <img className="w-100  lazy" src="../images/Catzap-organization.jpg" alt="Catzapp offers organizations their own customized application that enhances internal recruitment." />

                                </div>

                            </div>

                        </div>
                    </div>

                    <div className="section" id="section_contact">
                        <div className="container">

                            <h1 className="display-5 fw-bold mb-3 topic Contact-us-title fs-2">
                                {t('Contact us')}
                            </h1>


                            <div className="row g-xl-5">

                                <div className="col-12 col-lg-8 mb-4">



                                    <div>




                                        <div className="form-floating mb-3">
                                            <input maxLength={50} required placeholder="Name" id="contact_name" name="contact_name" type="text" className="form-control" value={name} onChange={(e)=>setName(e.target.value)}/>
                                            <label for="contact_name">{t('Name')}</label>
                                        </div>

                                        <div className="form-floating mb-3">
                                            <input maxLength={50} required placeholder="Email" id="contact_email" name="contact_email" type="email" className="form-control" value={email} onChange={(e)=>setEmail(e.target.value)}/>
                                            <label for="contact_email">{t('Email')}</label>
                                        </div>

                                        <div className="form-floating mb-3">
                                            <input required placeholder="Phone" id="contact_phone" name="contact_phone" type="number" className="form-control" value={phone} onChange={(e)=>setPhone(e.target.value)}/>
                                            <label for="contact_phone">{t('Phone')}</label>
                                        </div>

                                        <div className="form-floating mb-3">
                                            <textarea maxLength={300} required placeholder="Message" id="contact_message" name="contact_message" className="form-control" rows="3"  value={message} onChange={(e)=>setMessage(e.target.value)}></textarea>
                                            <label for="contact_message">{t('Messages')}</label>
                                        </div>

                                        <div className="row">
                                            {/* {/* <div className="col-md-6 col-lg-6 mb-3 pl-0 pr-0"> */}

                                                {/* <div className="form-floating mb-3">

                                                    <input type="text" id="norobot" className="form-control " placeholder="Security Code" required />

                                                    <label for="norobot">{t('Captcha')}</label>

                                                    <p id="msg"> </p>

                                                </div> */}

                                            {/* </div> */}

                                            {/* <div className="col-md-6 col-lg-6 mb-3">

                                                <div className="form-floating mb-3">

                                                    <div alt="" id="captcha" className=" rounded d-inline-block bg-cover captcha" data-gfont="Special Elite" ></div>

                                                    <input type="hidden" value="" id="randcode" name="randcode" />

                                                    <label for="contact:message">&nbsp;</label>

                                                </div>

                                                
                                            </div> */}

                                            {/* <div className="col-md-6 col-lg-6 mb-3">
                                                <div className="form-floating mb-3">
                                                    <div className="rounded d-inline-block bg-cover captcha" style={{ fontFamily: 'Special Elite' }}>
                                                        {captchaText}
                                                    </div>
                                                    <input type="hidden" value="" id="randcode" name="randcode" />
                                                    <label for="contact:message">&nbsp;</label>
                                                </div>
                                            </div> */}

                                        </div>



                                        {/* <div id="ajax_dd_contact_response_container"></div>

<div id="contactErrorUnexpected" class="hide alert alert-danger p-3">
    Unexpected Error!
</div>

<div id="contactErrorMandatory" class="hide alert alert-danger p-3">
    Please, review your data and try again!
</div>

<div id="contactSuccess" class="hide alert alert-success p-3">
    sucees Message
</div> */}





                                        <button type="submit" class="btn btn-dark btn-contact " id="btn-contact" onClick={()=>submit()}>
                                            {t('send Message')}
                                        </button>

                                    </div>


                                </div>


                                <div className="col-12 col-lg-4 mb-4">
                                    <div className="blockquote mb-2  mx-auto fw-light mb-4">
                                        <p className="fs-5 mb-3">{t("Catzapp Jobs Connects employees and employer lightning fast")}!</p>

                                        <footer className="blockquote-footer">
                                            {t('Mika')}
                                        </footer>

                                    </div>
                                    <div className="d-flex">

                                        <div className="float-none me-3">
                                            <i class="fa-sharp fa-regular fa-grip-dots"></i>
                                        </div>

                                        <div>

                                            <h2 className="fs-5">{t('Catzapp Software Ltd Oü,')}</h2>
                                            <ul className="list-unstyled m-0 fs-6">
                                                <li className="list-item text-muted">{t('Kaarli pst 11,')}</li>
                                                <li className="list-item text-muted">10119 {t('Tallinn Estonia')}</li>

                                            </ul>
                                        </div>

                                    </div>





                                    <div className="d-flex mt-4">

                                        <div className="float-none me-3">
                                            <i class="fa-solid fa-phone-volume"></i>
                                        </div>

                                        <div>
                                            <h3 className="h5">{t('Phone')}</h3>
                                            <ul className="list-unstyled m-0">
                                                <li className="list-item mb-2 text-gray-500">
                                                    <a className="link-muted" href="tel:+37254580320">+372 5458 0320</a>
                                                </li>

                                            </ul>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>

                    <footer id="footer" className="shadow-xs">




                        <div className="border-top" style={{ background: 'white' }}>
                            <div className="container text-center py-5">


                                <img src="../images/logo-dark3.png" width="110" alt="CatzApp Job logo" />

                                {/* <p className="m-0 text-gray-500 fs-6">

                                    &copy; {t('Catzapp Software Ltd Oü.')}




                                </p> */}
                                <p
                                    className="m-0 text-gray-500 fs-6">{t('All Rights Reserved')}</p>


                                <div className="mt-2">


                                    <a href="#" className="btn btn-sm btn-light transition-hover-top mb-2 rounded-circle" rel="noopener" aria-label="facebook page">
                                        <i class="fa-brands fa-facebook"></i>
                                    </a>

                                    <a href="#" className="btn btn-sm btn-light transition-hover-top mb-2 rounded-circle" rel="noopener" aria-label="twitter page">
                                        <i class="fa-brands fa-twitter"></i>
                                    </a>

                                    <a href="#" className="btn btn-sm btn-light transition-hover-top mb-2 rounded-circle" rel="noopener" aria-label="linkedin page">
                                        <i class="fa-brands fa-linkedin"></i>
                                    </a>

                                    <a href="#" className="btn btn-sm btn-light transition-hover-top mb-2 rounded-circle" rel="noopener" aria-label="youtube page">
                                        <i class="fa-brands fa-youtube"></i>
                                    </a>





                                </div>


                            </div>
                        </div>

                    </footer>



                    {/* </div> */}



                </div >






            </div >
        </div >
    )
}

export default LandingPage